import React from 'react';
import { IconButton } from '@material-ui/core';

const style = {
  width: '1rem',
  height: '1rem',
  marginLeft: '0.75rem',
  marginBottom: '0.25rem',
};
const ActionIcon = ({ disabled, onClick, icon }) => (
  <IconButton style={style} disabled={disabled} onClick={onClick}>
    {icon}
  </IconButton>
);

export default ActionIcon;
